"use client";

import { useEffect, useState } from "react";

const supportedLocales = [
  "en",
  "es",
  "fr",
  "zh",
  "hi",
  "uk",
  "ru",
  "kk",
] as const;
export type SupportedLocale = (typeof supportedLocales)[number];

export function useTranslations() {
  const [translations, setTranslations] = useState<Record<string, string>>({});

  useEffect(() => {
    const loadTranslations = async () => {
      const storedLocale = localStorage.getItem("locale") || "en";
      const locale = supportedLocales.includes(storedLocale as SupportedLocale)
        ? (storedLocale as SupportedLocale)
        : ("en" as const);
      const res = await fetch(`/api/translations/${locale}`);
      const data = await res.json();
      setTranslations(data);
    };

    loadTranslations();
  }, []);

  const t = (key: string) => translations[key] || key;

  return { t };
}

export function getDefaultLanguage(): SupportedLocale {
  if (typeof window === "undefined") return "en";

  const browserLang = navigator.language.split("-")[0];
  return supportedLocales.includes(browserLang as SupportedLocale)
    ? (browserLang as SupportedLocale)
    : ("en" as const);
}
